// extracted by css-extract-rspack-plugin
export default {"sectionImage":"sectionImage-1KHNB"};